// extracted by mini-css-extract-plugin
export default {"paymentOptions":"jvbvX2Y","provider":"CDnbQF2"};